export const PRIVACY_POLICY = `Privacy Policy

Effective Date: December 5, 2025

This Privacy Policy describes how Kwajongen.top ("we," "us," or "our") collects, uses, and shares information about you when you visit and interact with our website, kwajongen.top (the "Site").

IMPORTANT: [!!! YOU MUST REPLACE THIS BRACKETED TEXT !!!]

1. Contact Information

The Data Controller responsible for your personal data is:

Entity Name: [Legal Name of Your Business/Owner]
Address: [Your Business or Personal Address]
Email: [A Dedicated Legal/Privacy Contact Email Address, e.g., privacy@kwajongen.top]
Website: https://kwajongen.top

2. Information We Collect

We collect information that falls into the following categories:

A. Information You Provide Directly

This includes any information you voluntarily submit to us, such as:

Contact Data: Your name, email address, and any messages when you use a contact form or send us an email.

Account Data (If Applicable): Username, password, and any profile information if the Site requires user registration.

Feedback/Survey Data: Your responses to surveys or feedback forms.

B. Information Collected Automatically (Usage Data)

When you access the Site, we automatically collect certain information about your device and activity:

Device and Browser Information: IP address, browser type, operating system, and device identifiers.

Usage Details: Information about how you use the Site, including pages viewed, links clicked, time spent on pages, and referring URLs.

Location Data: General location data inferred from your IP address.

Cookies and Tracking: We use cookies and similar technologies (like web beacons or pixels) to collect this data.

[!!! DISCLOSURE FOR THIRD-PARTY ANALYTICS/ADS: If you use Google Analytics, Facebook Pixel, or other third-party tracking, you must specifically list them here and link to their privacy policies. Example: We use Google Analytics to measure website traffic. You can learn how Google uses data when you use our Site here: [Link to Google's Privacy Policy]. !!!]

3. How We Use Your Information

We use the information we collect for the following purposes:

Purpose

Legal Basis (GDPR/EU requirement)

Provide and Maintain the Site

Performance of a contract with you (Terms of Service) and our legitimate interests (site stability).

Improve, Personalize, and Expand the Site

Our legitimate interests (improving our services based on user behavior).

Communicate with You

Your consent (when you sign up for a newsletter) or our legitimate interests (responding to contact requests).

Marketing and Promotions

Your explicit consent (opt-in to marketing communications).

Security and Fraud Prevention

Our legitimate interests (protecting our assets and detecting malicious activity).

Compliance with Law

Compliance with a legal obligation.

4. Sharing Your Information

We may share your information with the following categories of recipients:

Service Providers: Third-party vendors who perform services on our behalf (e.g., website hosting, data analytics, email delivery). These parties are required to protect your data.

Legal Compliance: When required by law (e.g., a court order or subpoena), or to protect our rights or the safety of others.

Business Transfers: In connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business by another company.

5. Data Retention

We retain your personal information only for as long as is necessary for the purposes set out in this Privacy Policy. Generally, this means:

Account Data is retained until you delete your account or request deletion.

Usage Data is typically retained for [!!! Specify Your Analytics Retention Period, e.g., 26 months for Google Analytics !!!] before being anonymized or deleted.

6. Your Data Protection Rights

Depending on your location (e.g., EU residents under GDPR, California residents under CCPA), you may have the following rights regarding your personal data:

Right to Access: The right to request copies of your personal data.

Right to Rectification: The right to request that we correct any information you believe is inaccurate or incomplete.

Right to Erasure (Right to be Forgotten): The right to request that we erase your personal data, under certain conditions.

Right to Restrict Processing: The right to request that we restrict the processing of your personal data, under certain conditions.

Right to Object to Processing: The right to object to our processing of your personal data, under certain conditions.

Right to Data Portability: The right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.

To exercise any of these rights, please contact us at [Your Dedicated Legal/Privacy Contact Email Address, e.g., privacy@kwajongen.top].

7. Changes to This Privacy Policy

We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Effective Date" at the top. You are advised to review this Privacy Policy periodically for any changes.`;

export const TERMS_OF_SERVICE = `Terms of Service

Effective Date: December 5, 2025

These Terms of Service ("Terms") govern your use of Kwajongen.top (the "Site"). By accessing or using the Site, you agree to be bound by these Terms. If you do not agree, do not use the Site.

1. Eligibility

You must be at least 13 years old (or older if required by your jurisdiction) to use the Site. By using the Site, you represent that you meet this requirement.

2. Accounts and Security

If the Site allows you to create an account, you must provide accurate information and keep your credentials secure. You are responsible for all activity under your account.

3. Acceptable Use

You agree not to:

- Violate any applicable laws or regulations.
- Interfere with or disrupt the Site or the servers or networks connected to the Site.
- Upload or transmit viruses, malware, or other harmful code.
- Attempt to gain unauthorized access to any portion of the Site.

4. Intellectual Property

All content on the Site, including text, graphics, logos, and software, is owned by us or our licensors and is protected by applicable copyright and trademark laws.

5. Termination

We may suspend or terminate your access to the Site at any time, for any reason, without prior notice or liability.

6. Disclaimer of Warranties

The Site is provided on an "AS IS" and "AS AVAILABLE" basis. We make no warranties, express or implied, regarding the Site or its content.

7. Limitation of Liability

To the fullest extent permitted by law, we will not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of your use of or inability to use the Site.

8. Indemnification

You agree to indemnify and hold us harmless from any claims, liabilities, damages, losses, or expenses (including attorneys' fees) arising out of or in connection with your use of the Site or violation of these Terms.

9. Governing Law

These Terms are governed by the laws of Belgium, without regard to its conflict of law principles.

10. Changes to These Terms

We may update these Terms from time to time. The updated Terms will be posted on this page with a new "Effective Date." Your continued use of the Site after we post changes constitutes your acceptance of the updated Terms.

11. Contact Us

If you have any questions about these Terms, please contact us at privacy@kwajongen.top.`;
